import { render, staticRenderFns } from "./DeclareChangeHintDialog.vue?vue&type=template&id=793fe4ca&"
import script from "./DeclareChangeHintDialog.vue?vue&type=script&lang=js&"
export * from "./DeclareChangeHintDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeclareChangeHintDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports